export const MODULE_MASTER = {
  ORGANIZATIONS: 1,
  COMPANIES: 2,
  ENTITIES: 3,
  ADDRESS: 4,
  ITEMS: 5,
  DEVICES: 8,
  CONTACTS: 9,
  ALERTRULE: 12,
};

export const ADDRESS_TYPES = {
  PHONE: 1,
  EMAIL: 2,
  FAX: 3,
};

export const RULES = [
  { rule: "alert", module_id: 12 },
  { rule: "service request", module_id: 13 },
  { rule: "job state alert", module_id: 22 },
];

export const MESSAGE_TEMPLATE_VARIABLES = [
  "ORGANIZATION NAME",
  "COMPANY NAME",
  "ENTITY NAME",
  "ENTITY FIRSTNAME",
  "ENTITY LASTNAME",
  "ENTITY TYPE",
  "ENTITY ADDRESS ITEM",
  "ENTITY ADDRESS NAME",
  "SERVICE ITEM NAME",
  "STATUS NAME",
  "BATTERY STATUS",
  "BATTERY VOLTAGE",
  "FLUID LEVEL",
  "PERCENT LEVEL",
  "VOLUME LEVEL",
  "TEMPERATURE",
  "ITEM NAME",
  "ITEM TYPE",
  "DEVICE NAME",
  "DEVICE TYPE",
  "DEVICE BRAND",
  "DEVICE MODEL",
  "DEVICE MONITOR STATUS",
  "DEVICE MONITOR NAME",
  "DEVICE MONITOR FREQUENCY",
  "DEVICE MONITOR TIME UNIT",
  "ALERT_VALUE",
  "THRESHOLD_VALUE",
  "REQUEST DATE",
  "VIEW REQUEST URL",
  "THRESHOLD_NAME",
  "THRESHOLD_LABEL",
  "THRESHOLD_COMPARISON_OPERATOR",
  "THRESHOLD_COMPARISON_LABEL",
];

export const PROMPT_TEMPLATE_VARIABLES = [
  "COMPANY ID",
  "COMPANY NAME",
  "COMPANY PHONE",
  "COMPANY EMAIL",
  "COMPANY URL",
  "COMPANY ADDRESS 1",
  "COMPANY ADDRESS 2",
  "COMPANY STATE",
  "COMPANY CITY",
  "COMPANY POSTAL CODE",
  "COMPANY COUNTRY",
  "COMPANY CATEGORY",
  "DEVICE NAME",
  "DEVICE TYPE",
  "DEVICE BRAND",
  "DEVICE MODEL",
  "TEMPLATE NAME",
];

export const colorConst = {
  80: "success",
  54: "primary",
  78: "info",
  75: "error",
};

export const SHOW_COLUMNS = [
  "Company ID",
  "Dashboard",
  "dashboard view",
  "Company name",
  "Company Phone",
  "Company URL",
  "Company Email",
  "address 1",
  "address 2",
  "city",
  "state",
  "postal code",
  "category",
  "Latitude",
  "Longitude",
  "Map",
  "last event",
  "event count",
  "interest",
  "Recent Notes",
  "Contacts Logs",
  "Event Logs",
  "Collateral Logs",
];

export const COLUMN_SETTING = [
  {
    column_name: "Company ID",
    column_type: "text",
    is_visible: true,
    position: 1,
    backend_reference: "company_id",
    field_reference: "company_id",
  },
  {
    column_name: "Dashboard",
    column_type: "text",
    is_visible: true,
    position: 2,
    backend_reference: "dashboard",
    field_reference: "dashboard_url",
  },
  {
    column_name: "dashboard view",
    column_type: "text",
    is_visible: true,
    position: 3,
    backend_reference: "dashboard_view",
    field_reference: "CampaignCompany.CampaignCollateralEventsCount",
  },
  {
    column_name: "Company name",
    column_type: "text",
    is_visible: true,
    position: 4,
    backend_reference: "company_name",
    field_reference: "CampaignCompany.company_name",
  },
  {
    column_name: "Company Phone",
    column_type: "text",
    is_visible: true,
    position: 5,
    backend_reference: "company_phone",
    field_reference: "CampaignCompany.company_phone",
  },
  {
    column_name: "Company URL",
    column_type: "text",
    is_visible: true,
    position: 6,
    backend_reference: "company_url",
    field_reference: "CampaignCompany.company_url",
  },
  {
    column_name: "Company Email",
    column_type: "text",
    is_visible: true,
    position: 7,
    backend_reference: "company_email",
    field_reference: "CampaignCompany.company_email",
  },
  {
    column_name: "address 1",
    column_type: "text",
    is_visible: true,
    position: 8,
    backend_reference: "primary_street_address1",
    field_reference: "CampaignCompany.primary_street_address1",
  },
  {
    column_name: "address 2",
    column_type: "text",
    is_visible: true,
    position: 9,
    backend_reference: "primary_street_address2",
    field_reference: "CampaignCompany.primary_street_address2",
  },
  {
    column_name: "city",
    column_type: "text",
    is_visible: true,
    position: 10,
    backend_reference: "primary_city",
    field_reference: "CampaignCompany.primary_city",
  },
  {
    column_name: "state",
    column_type: "text",
    is_visible: true,
    position: 11,
    backend_reference: "primary_state",
    field_reference: "CampaignCompany.primary_state",
  },
  {
    column_name: "postal code",
    column_type: "text",
    is_visible: true,
    position: 12,
    backend_reference: "primary_postal_code",
    field_reference: "CampaignCompany.primary_postal_code",
  },
  {
    column_name: "category",
    column_type: "text",
    is_visible: true,
    position: 13,
    backend_reference: "company_category",
    field_reference: "CampaignCompany.company_category",
  },
  {
    column_name: "Latitude",
    column_type: "text",
    is_visible: true,
    position: 14,
    backend_reference: "latitude",
    field_reference: "CampaignCompany.latitude",
  },
  {
    column_name: "Longitude",
    column_type: "text",
    is_visible: true,
    position: 15,
    backend_reference: "longitude",
    field_reference: "CampaignCompany.longitude",
  },
  {
    column_name: "Map",
    column_type: "text",
    is_visible: true,
    position: 16,
    backend_reference: "map",
  },
  {
    column_name: "last event",
    column_type: "text",
    is_visible: true,
    position: 17,
    backend_reference: "LastEventTimestamp",
    field_reference: "LastEventTimestamp",
  },
  {
    column_name: "event count",
    column_type: "text",
    is_visible: true,
    position: 18,
    backend_reference: "CampaignEventCount",
    field_reference: "CampaignEventCount",
  },
  {
    column_name: "interest",
    column_type: "text",
    is_visible: true,
    position: 19,
    backend_reference: "LastInterest",
    field_reference: "LastInterest",
  },
  {
    column_name: "Recent Notes",
    column_type: "text",
    is_visible: true,
    position: 20,
    backend_reference: "most_recent_notes",
    field_reference: "recentNotes",
  },
  {
    column_name: "Contacts Logs",
    column_type: "text",
    is_visible: true,
    position: 21,
    backend_reference: "CampaignContact",
  },
  {
    column_name: "Event Logs",
    column_type: "text",
    is_visible: true,
    position: 22,
    backend_reference: "CampaignEvents",
  },
  {
    column_name: "Collateral Logs",
    column_type: "text",
    is_visible: true,
    position: 23,
    backend_reference: "CampaignCollateralAttributeValues",
  },
];

export const HIDE_COLUMNS = [
  "Current Population",
  "Peak Population",
  "Devices",
  "Dashboard Image",
  "Dashboard Devices",
  "Dashboard Url",
  "Dashboard Template",
  "Email Template Id",
  "Target Sell Application",
  "Send From Email",
  "Email Contact",
];

export const JOBQUEUE_SHOW_COLUMNS = [
  "Status",
  "ID",
  "Campaign Id",
  "Company Name",
  "Company Phone",
  "Company Email",
  "website",
  "category",
  "address 1",
  "address 2",
  "city",
  "state",
  "postal code",
  "Latitude",
  "Longitude",
  "last event",
  "event count",
  "interest",
  "Recent Notes",
  "Collateral Logs",
  "Event Logs",
];

export const JOBQUEUE_HIDE_COLUMNS = [
  "Current Population",
  "Peak Population",
  "Devices",
  "Dashboard Image",
  "Dashboard Devices",
  "Dashboard Url",
  "Dashboard Template",
  "Email Template Id",
  "Target Sell Application",
  "Send From Email",
  "Email Contact",
];

export const JSONTreeTheme = {
  scheme: "monokai",
  author: "wimer hazenberg (http://www.monokai.nl)",
  base00: "#272822",
  base01: "#383830",
  base02: "#49483e",
  base03: "#75715e",
  base04: "#a59f85",
  base05: "#f8f8f2",
  base06: "#f5f4f1",
  base07: "#f9f8f5",
  base08: "#f92672",
  base09: "#fd971f",
  base0A: "#f4bf75",
  base0B: "#a6e22e",
  base0C: "#a1efe4",
  base0D: "#66d9ef",
  base0E: "#ae81ff",
  base0F: "#cc6633",
};

export const JSONTreeDarkTheme = {
  scheme: 'default',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#1a2035',
  base01: '#282828',
  base02: '#383838',
  base03: '#585858',
  base04: '#b8b8b8',
  base05: '#d8d8d8',
  base06: '#e8e8e8',
  base07: '#f8f8f8',
  base08: '#ab4642',
  base09: '#dc9656',
  base0A: '#f7ca88',
  base0B: '#a1b56c',
  base0C: '#86c1b9',
  base0D: '#fff',
  base0E: '#ba8baf',
  base0F: '#a16946'
};


export const validateInput = (field_type_id, value) => {
  switch (field_type_id) {
    case 2:
      if (!Number.isInteger(parseInt(value, 10))) {
        return "Value must be an integer";
      }
      break;
    case 3:
      if (!/^-?\d+\.\d+$/.test(value)) {
        return "Value must be a float";
      }
      break;
    case 4:
      if (!["true", "false", "1", "0"].includes(value.toLowerCase())) {
        return "Value must be a boolean (true/false or 1/0)";
      }
      break;
    case 5:
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return "Value must be a valid date (YYYY-MM-DD)";
      }
      break;
    case 6:
      if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
        return "Value must be a valid datetime (YYYY-MM-DD HH:MM:SS)";
      }
      break;
    case 7:
      if (!/^\d{10}$/.test(value)) {
        return "Value must be a valid timestamp (10 digits)";
      }
      break;
    case 8:
      if (value.length > 255) {
        return "Value must be less than or equal to 255 characters";
      }
      break;
    case 9:
      // Add specific validation logic for list type
      if (!Array.isArray(value)) {
        return "Value must be list";
      }
      break;
    default:
      // No specific validation for other field types
      return null;
  }

  // If validation passes
  return null;
};

export const formatDuration = (seconds) => {
  if (seconds < 60) return `${seconds} sec`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min`;
  return `${(seconds / 3600).toFixed(1)} hrs`;
};

export const counter_data = ['ignition_seconds', 'current_ignition_seconds', 'moving_seconds', 'idle_seconds', 'parking_seconds', 'current_mileage']
export const show_current_data = ['moment_status', 'moment_status_duration', 'position_speed', 'position_direction', 'position_latitude', 'position_longitude', 'position_altitude', 'battery_level', 'battery_voltage', 'external_powersource_status', 'external_powersource_voltage', 'engine_ignition_status', 'vehicle_mileage', 'din', 'dout', 'device_temperature', 'fuel_consumed', 'average_fuel_consumption', 'can_engine_rpm', 'can_fuel_level', 'can_intake_map', 'can_engine_load_level', 'can_maf_air_flow_rate', 'can_throttle_pedal_level', 'can_intake_air_temperature', 'can_engine_coolant_temperature', 'vehicle_vin']
export const show_device_signal_data = ['din_1', 'din_2', 'din_3', 'din_4', 'din_5', 'din_6', 'dout_1', 'dout_2', 'dout_3', 'ain_0', 'ain_1', 'ain_2']
export const show_transmission_data = ['gsm_network_name', 'gsm_sim_iccid', 'gsm_sim_imsi', 'gnss_status', 'gsm_signal_level', 'position_satellites']
export const show_device_setting = ['angleThreshold', 'blindMaxTime', 'detectionTime', 'deviceType', 'fallFunction', 'hardwareVersion', 'heightThreshold', 'imsi', 'serverMode', 'temperatureThreshold', 'ultrasonicRange', 'uploadTime', 'workMode']

export const gpsStatusBadgeColor = (status) => {
  if (!status) return 'secondary';
  const s = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  let res;
  if (s == 'Moving') {
      res = 'success'
  }
  if (s == 'Idle') {
      res = 'warning'
  }
  if (s == 'Parked') {
      res = 'secondary'
  }
  if (s == 'Delayed') {
      res = 'info'
  }
  return res || 'secondary'
}

export const serviceRequestStatusColor = (status) => {
  let res = '#d1ffd6';
  let smStatus = status.toLowerCase();
  if(smStatus == 'warning'){
    res = '#fb8c00'
  }
  if(smStatus == 'secondary'){
    res = '#7b809a'
  }
  if(smStatus == 'info'){
    res = '#1A73E8'
  }
  return res;
}

export const deviceSetupShapes = [
  'Circle', 
  'Square', 
  'Rectangle', 
  'cylinder_vertical', 
  'cylinder_horizontal'
]

export const fieldMapping = {
  31: "length",
  32: "width",
  33: "depth",
  34: "shape",
  46: "latitude",
  47: "longitude",
};

export const JOB_STATES = [
  'IDLE', 'SETUP', 'PUMPING', 'HOLD', 'LOADED', 'FINISHING',
  'DISCHARGE', 'VERIFY_EMPTY', 'COMPLETE', 'ABORTED', 'ERROR',
  'IN_USE', 'HIGH_USAGE', 'LOW_WATER', 'DRAINING', 'EMPTY',
  'REFILLING', 'READY'
];